import { AnyMxRecord } from 'dns';
import { forEach } from 'lodash';
import io from 'socket.io-client';

enum LoggerStatusEnum {
  debug = 'debug',
  info = 'info',
  warn = 'warn',
  error = 'error',
}

type SendLog = (
  message: string,
  messageContext: any,
  status: LoggerStatusEnum,
) => void;

let socket: SocketIOClient.Socket; // eslint-disable-line

// Default sendLog. We are re-assiginig this to sendLog from ui-model in the initiateSocket method
let sendSocketLog = (message, messageContext, status) => {
  // eslint-disable-next-line no-undef
  globalThis.console.log(message, messageContext, status);
};

export async function initiateSocket(userId: string, sendLog: SendLog) {
  const uri = `${process.env.REACT_APP_API_SOCKET}`;
  sendSocketLog = sendLog;
  socket = io(uri);
  const socketLog = {
    connected: socket.connected,
    id: socket.id,
    uri: socket.io.uri,
  };
  return new Promise((resolve) => {
    socket.on('connect_error', (error: any) => {
      sendLog(
        'Socket: connect_error',
        { socket: socketLog, error },
        LoggerStatusEnum.error,
      );
    });
    socket.on('connect_timeout', (timeout: any) => {
      sendLog(
        `Socket: connect_timeout (${timeout})`,
        { socket: socketLog },
        LoggerStatusEnum.error,
      );
    });
    socket.on('error', (error: any) => {
      sendLog(
        'Socket: error',
        { socket: socketLog, error },
        LoggerStatusEnum.error,
      );
    });
    socket.on('reconnect_error', (error: any) => {
      sendLog(
        'Socket: reconnect_error',
        { socket: socketLog, error },
        LoggerStatusEnum.error,
      );
    });
    socket.on('reconnect_failed', () => {
      sendLog(
        'Socket: reconnect_failed',
        { socket: socketLog },
        LoggerStatusEnum.error,
      );
    });
    socket.on('reconnect', (attemptNumber: any) => {
      sendLog(
        `Socket: reconnect (${attemptNumber})`,
        { socket: socketLog },
        LoggerStatusEnum.info,
      );
    });
    socket.on('reconnect_attempt', (attemptNumber: any) => {
      sendLog(
        `Socket: reconnect_attempt (${attemptNumber})`,
        { socket: socketLog },
        LoggerStatusEnum.info,
      );
    });
    socket.on('reconnecting', (attemptNumber: any) => {
      sendLog(
        'Socket: reconnecting',
        { socket: socketLog, attemptNumber },
        LoggerStatusEnum.info,
      );
    });
    socket.on('disconnect', (reason: any) => {
      if (reason === 'io server disconnect') {
        sendLog(
          `Socket: disconnect from server (${reason})`,
          { socket: socketLog },
          LoggerStatusEnum.error,
        );
        // Disconnection initiated by the server, try to reconnect
        socket.connect();
      } else {
        sendLog(
          `Socket: disconnect (${reason})`,
          { socket: socketLog },
          LoggerStatusEnum.info,
        );
      }
    });
    return socket.on('connect', () => {
      sendLog(
        'Socket: connected',
        { socket: socketLog },
        LoggerStatusEnum.info,
      );
      // Register current user
      socket.emit('register', { id: userId, app: 'web-app' });
      sendLog(
        `Socket: user registered (${userId})`,
        { socket: socketLog },
        LoggerStatusEnum.info,
      );
      resolve(socket);
    });
  });
}

export function subscribeSocketEvents(
  events: string[],
  callback: (data: AnyMxRecord) => void,
) {
  if (!socket) {
    sendSocketLog(
      `Socket: subscribing to events but no socket available`,
      { events },
      LoggerStatusEnum.warn,
    );
    return;
  }
  forEach(events, (event) => {
    console.log('subscribed');
    socket.on(event, callback);
  });
}

export function unsubscribeSocketEvents(
  events: string[],
  cb: (data: any) => void,
) {
  if (!socket) {
    sendSocketLog(
      `Socket: unsubscribing from events but no socket available`,
      { events },
      LoggerStatusEnum.warn,
    );
    return;
  }
  forEach(events, (event) => socket.off(event, cb));
}
